export const AgentString = {
    title: 'Utenti',
    addAgent: 'Aggiungi Utente',
    name:'Nome',
    surname:'Cognome',
    email: 'Email',
    agency: 'Agenzia',
    actions: 'Azioni',
    status_active : 'Attivo',
    status_suspended : 'Sospeso',
    status_disabled : 'Disabilitato',
    status_expired : 'Scaduto',
    editAgent: 'Modifica Utente',
    viewAgent: 'Visualizza Utente',
    percentage:'Opportunità Attive',
    password:'Password',
    confirmPassword:'Conferma password',
    is_boss:'È il boss dell\'agenzia'
    
    

}